// "Share my time" from the solved sheet (Workbench, 2026-10-19): a short,
// spoiler-free line to text a friend - the day, the title, the time and how
// it went - and a link straight to that puzzle (?puzzle=<date>). Pure, so
// the wording and the link check are tested.
import { formatTime } from '@/engine/solving';
import { isGiantId, seasonById } from '@/engine/seasons';

/** A link that opens one puzzle: a date or a Giant id. */
export const puzzleLink = (origin, date) => `${origin}/?puzzle=${encodeURIComponent(date)}`;

function dayLabel(date) {
  const d = new Date(`${date}T12:00:00`);
  return d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
}

/** The message: never a theme answer, never a letter of the grid. */
export function shareResultText({
  puzzle, seconds, clean, together, origin,
}) {
  const time = formatTime(seconds);
  let how;
  if (!clean) how = `Solved in ${time} with help`;
  else if (together) how = `Solved together in ${time}`;
  else how = `Solved clean in ${time}`;
  const season = puzzle.giant ? seasonById(puzzle.season || puzzle.date) : null;
  let when = dayLabel(puzzle.date);
  if (puzzle.giant) when = season ? `the ${season.name} Giant` : 'the Giant';
  return `Crossword · ${when} · “${puzzle.title}”\n${how}\n${puzzleLink(origin, puzzle.date)}`;
}

/**
 * A ?puzzle= value worth opening, or null: a past or present date, or a
 * Giant whose season has begun. The app never shows a future puzzle, and a
 * link must not be the way round that.
 */
export function openablePuzzle(value, today) {
  const v = String(value || '');
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v <= today ? v : null;
  if (isGiantId(v)) {
    const season = seasonById(v);
    return season && season.startsOn <= today ? season.giantId : null;
  }
  return null;
}
